<template>
    <div class="timerContainer">
        <div class="circle">
            <svg viewBox="0 0 220 220">
                <g transform="translate(110,110)">
                    <circle r="100" class="e-c-base"/>
                    <g transform="rotate(-90)">
                        <circle r="100" class="e-c-progress" v-bind:style="[progressBarStyle, primaryStrokeStyle]"/>
                        <g id="e-pointer" v-bind:style="pointerStyle">
                            <circle cx="100" cy="0" r="8" class="e-c-pointer" v-bind:style="primaryStrokeStyle"/>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
        <div class="timerControl">
            <div class="display-remain-time display-4" v-bind:style="primaryColorStyle">{{ textTimeLeft }}</div>
            <button id="pause" v-on:click="toggleTimer">
                <div v-bind:class="{ play: isPaused || !isStarted, pause: isStarted && !isPaused }" v-bind:style="controlButtonStyle"></div>
            </button>
        </div>
        <div>
            <v-btn color="primary" v-on:click="skip" v-bind:disabled="!isStarted">Skip</v-btn>
        </div>
    </div>
</template>

<script>
  export default {
    name: "Timer",
    props: {
      timeLength: {
        type: Number,
        default: 30
      },
      primaryColor: {
        default: '#FFFFFF'
      }
    },
    data: function () {
      return {
        timeLeft: 0,
        isPaused: false,
        isStarted: false,
        mutableTimeLength: this.timeLength,
        pointerStyle: {
          transform: 'rotate(360deg)'
        },
        progressBarStyle: {
          strokeDashoffset: '',
          strokeDasharray: Math.PI * 2 * 100
        },
        controlButtonStyle: {
          borderColor: this.primaryColor
        },
        primaryColorStyle: {
          color: this.primaryColor
        },
        primaryStrokeStyle: {
          stroke: this.primaryColor
        },
        internalTimer: null,
        textTimeLeft: '00:30',
        remainTime: 0
      }
    },
    methods: {
      toggleTimer: function () {
        if (!this.isStarted) {
          this.startCountdown(this.mutableTimeLength);

          this.isStarted = true;
          this.isPaused = false;


          this.$emit('on-started');
        } else if (this.isPaused) {
          this.startCountdown(this.timeLeft);

          this.isPaused = false;
        } else {
          clearInterval(this.intervalTimer);

          this.isPaused = true;
        }
      },
      startCountdown: function (seconds) {
        this.remainTime = Date.now() + (seconds * 1000);

        this.updateTimeLeft(seconds);

        this.intervalTimer = setInterval(this.countdown, 1000);
      },
      countdown: function () {
        this.timeLeft = Math.round((this.remainTime - Date.now()) / 1000);

        if (this.timeLeft < 0) {
          this.resetCountdown();
          return;
        }

        this.updateTimeLeft(this.timeLeft);
      },
      resetCountdown: function () {
        clearInterval(this.intervalTimer);

        this.isStarted = false;
        this.isPaused = false;

        this.updateTimeLeft(this.mutableTimeLength);

        let timeSpent = this.timeLeft < 0 ? this.mutableTimeLength : this.mutableTimeLength - this.timeLeft;

        this.$emit('on-completed', timeSpent);
      },
      updateTimeLeft: function (timeLeft) {
        let minutes = Math.floor(timeLeft / 60);
        let seconds = timeLeft % 60;
        this.textTimeLeft = `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

        this.updateProgressBar(timeLeft, this.mutableTimeLength);

        document.title = this.textTimeLeft;
      },
      updateProgressBar: function (value, timePercent) {
        let length = Math.PI * 2 * 100;
        this.progressBarStyle.strokeDashoffset = -length - length * value / (timePercent);

        let deg = 360 * value / (timePercent);
        this.pointerStyle.transform = 'rotate(' + deg + 'deg)'
      },
      changeTimeLength: function (seconds) {
        this.mutableTimeLength = seconds;

        this.resetCountdown();
      },
      skip: function () {
        this.resetCountdown()
      }
    },
    mounted: function () {
      this.updateTimeLeft(this.mutableTimeLength);
    }
  }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Roboto:100,300');

    .timerContainer {
        position: relative;
        max-width: 400px;
        margin: 0 auto;
        line-height: initial;
        text-align: center;
    }

    .timerControl {
        position: absolute;
        width: 100%;
        top: 32%;
        text-align: center;
    }

    .display-remain-time {
        font-family: 'Roboto';
        font-weight: 100;
        color: #F7958E;
    }

    #pause {
        outline: none;
        background: transparent;
        border: none;
        margin-top: 25px;
        width: 40px;
        height: 50px;
        position: relative;
    }

    .play {
        display: block;
        content: "";
        position: absolute;
        top: 8px;
        left: 8px;
        border-top: 25px solid transparent !important;
        border-bottom: 25px solid transparent !important;
        border-left: 37px solid;
    }

    .pause {
        content: "";
        position: absolute;
        top: 8px;
        left: 10px;
        width: 20px;
        height: 37px;
        background-color: transparent;
        border-radius: 1px;
        border: 8px solid #F7958E;
        border-top: none;
        border-bottom: none;
    }

    #pause:hover {
        opacity: 0.8;
    }

    .e-c-base {
        fill: none;
        stroke: #B6B6B6;
        stroke-width: 4px
    }

    .e-c-progress {
        fill: none;
        stroke: #F7958E;
        stroke-width: 4px;
        transition: stroke-dashoffset 0.7s;
    }

    .e-c-pointer {
        fill: #FFF;
        stroke: #F7958E;
        stroke-width: 2px;
    }

    #e-pointer {
        transition: transform 0.7s;
    }

    /*h1 {*/
    /*    margin-top: 150px;*/
    /*    text-align: center;*/
    /*}*/

    /*body {*/
    /*    background-color: #f7f7f7;*/
    /*}*/
</style>
